import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTag',
  props: {
  tag: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const tagClass = computed(() => `product-tag--${props.tag?.value || ''}`);
const tagName = computed(() => props.tag.label || props.tag.name || '');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['product-tag', _unref(tagClass)])
  }, _toDisplayString(_unref(tagName)), 3))
}
}

})